export default __webpack_public_path__ + "static/media/parent-new.a873c946.jpg";